import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { PageLayout, ConfirmDialog } from 'shared/ui';
import { Businesses, Header } from 'widgets';
import { UserRoleEnum, userStore } from 'entities/index';
import { AppLinks } from 'app/router/consts/app-links.enum';

export const BusinessesPage: React.FC = observer(() => {
  const navigate = useNavigate();
  const [showWarning, setShowWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');

  const role = userStore.role;
  const licExpireDays = userStore.licExpireDays;

  useEffect(() => {
    if (role !== UserRoleEnum.OWNER) return;
    if (licExpireDays >= 7) return;
    if (sessionStorage.getItem('licenseWarningShown')) return;

    const message =
      licExpireDays <= 0
        ? 'Подписка не активна. Выберите подходящий тариф.'
        : `Подписка заканчивается. Осталось ${licExpireDays} д.`;

    setWarningMessage(message);
    setShowWarning(true);
  }, [role, licExpireDays]);

  const handleWarningClose = () => {
    setShowWarning(false);
  };

  const handleWarningConfirm = (result: boolean) => {
    sessionStorage.setItem('licenseWarningShown', 'true');
    setShowWarning(false);
    if (result) {
      navigate(AppLinks.OwnerProfileLink);
    }
  };

  return (
    <PageLayout>
      <Header />
      <Businesses />
      {showWarning ? (
        <ConfirmDialog
          message={warningMessage}
          confirmText="Перейти в профиль"
          cancelText="Закрыть"
          onConfirm={handleWarningConfirm}
          onClose={handleWarningClose}
        />
      ) : null}
    </PageLayout>
  );
});
